// extracted by mini-css-extract-plugin
export default {"tabContent":"ScreenshotsMonitoringSection_tabContent__aiXvV"};